/**
 * Full Frame — fixed dropdown of role names for expense rows.
 * Order matches the user's intent (writers/director first, then crew, talent, special roles).
 */
export const FF_ROLES = [
  "תסריט",
  "במאי",
  "צלם 1",
  "סאונד",
  "עורך",
  "מפיק",
  "איפור",
  "מנהל הפקה",
  "שחקן/ית 1",
  "שחקן/ית 2",
  "שחקן/ית 3",
  "שחקן/ית 4",
  "רחפן",
  "תחבורה",
  "בעל תפקיד 1",
  "בעל תפקיד 2",
  "בעל תפקיד 3",
  "בעל תפקיד 4",
  "בעל תפקיד 5",
  "בעל תפקיד 6",
  "בעל תפקיד 7",
  "צלם 2",
  "צלם 3",
];

export const FF_VAT_RATE = 0.18;
